module.exports = __webpack_public_path__ + "img/empty.f3330761.png";